import React from "react";

// Lightweight markdown renderer (very simple subset) — avoids bringing another dep
export default function Markdown({ children }) {
  const text = String(children || "");
  const lines = text.split(/\n/);
  const rendered = [];
  let listBuf = [];
  const flushList = () => {
    if (listBuf.length) {
      rendered.push(<ul key={`ul-${rendered.length}`} className="list-disc pl-6 space-y-1 text-white/90">{listBuf}</ul>);
      listBuf = [];
    }
  };

  const inline = (s) => {
    const parts = s.split(/(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g);
    return parts.map((p, i) => {
      if (p.startsWith("**") && p.endsWith("**")) return <strong key={i} className="text-white">{p.slice(2, -2)}</strong>;
      if (p.startsWith("*") && p.endsWith("*")) return <em key={i}>{p.slice(1, -1)}</em>;
      if (p.startsWith("`") && p.endsWith("`")) return <code key={i} className="bg-white/5 px-1">{p.slice(1, -1)}</code>;
      return <span key={i}>{p}</span>;
    });
  };

  lines.forEach((line, i) => {
    if (/^\s*[-*]\s+/.test(line)) {
      listBuf.push(<li key={i}>{inline(line.replace(/^\s*[-*]\s+/, ""))}</li>);
      return;
    }
    flushList();
    if (/^###\s+/.test(line)) rendered.push(<h4 key={i} className="font-display uppercase font-black text-lg tracking-tight mt-4">{line.replace(/^###\s+/, "")}</h4>);
    else if (/^##\s+/.test(line)) rendered.push(<h3 key={i} className="font-display uppercase font-black text-xl tracking-tight mt-6">{line.replace(/^##\s+/, "")}</h3>);
    else if (/^#\s+/.test(line)) rendered.push(<h2 key={i} className="font-display uppercase font-black text-2xl tracking-tight mt-6">{line.replace(/^#\s+/, "")}</h2>);
    else if (line.trim() === "") rendered.push(<div key={i} className="h-2" />);
    else rendered.push(<p key={i} className="text-white/85 leading-relaxed">{inline(line)}</p>);
  });
  flushList();

  return <div className="space-y-1">{rendered}</div>;
}
